import { render, staticRenderFns } from "./CostPerSectorCalcForm.vue?vue&type=template&id=1a180002&scoped=true&lang=html&"
import script from "./CostPerSectorCalcForm.vue?vue&type=script&lang=js&"
export * from "./CostPerSectorCalcForm.vue?vue&type=script&lang=js&"
import style0 from "./CostPerSectorCalcForm.vue?vue&type=style&index=0&id=1a180002&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a180002",
  null
  
)

export default component.exports